/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionState } from './submissionState';

export type SubmissionCreateRequestState = SubmissionState | null;
